import { isArray } from "lodash";
import { TOASTIFY_STATUS } from "../constants/application";
import { GENERIC_ERROR_MESSAGE } from "../constants/common";
import { AUTHENTICATION_TOKEN } from "../constants/storage";
import { getCookie } from "../helpers/browserStorage";
import { notifyToaster } from "../helpers/common";
import { store } from "../redux/Store";
import { setVehicles } from "../redux/slices/VehicleSlice";
import CustomError from "../utils/customError";
import {getJSON, patchJSON} from "../utils/fetch";

const API_ENDPOINT = `${process.env.REACT_APP_API_HOST}/api/v6/fleet`;
const VEHICLES = "vehicles";
const API_ENDPOINT_V4 = `${process.env.REACT_APP_API_HOST}/api/v4`;

export const updateVehicles = async ({ vehicleId, apiPayload }) => {
  try {
    const response = await patchJSON(
      `${API_ENDPOINT}/${VEHICLES}/${vehicleId}`,
      apiPayload,
      {
        Authorization: getCookie(AUTHENTICATION_TOKEN),
      }
    );

    if (response.error) {
      const errorsArray = isArray(response.error)
        ? response.error
        : [response.error || GENERIC_ERROR_MESSAGE];

      notifyToaster(errorsArray.join(" "), {
        type: TOASTIFY_STATUS.error,
      });

      throw new CustomError("error", errorsArray);
    }

    return response;
  } catch (error) {
    // If the error is a CustomError, rethrow the error details array
    if (error instanceof CustomError) {
      throw error.details;
    }

    // For any other error, normalize it into an array and throw it
    throw [error.message];
  }
};

export const getVehicles = async ({ fleetId }) => {
  try {
    const response = await getJSON(
      `${API_ENDPOINT_V4}/${VEHICLES}`,
      {
        'fleet_id': fleetId,
      },
      {
        Authorization: getCookie(AUTHENTICATION_TOKEN),
      }
    );

    if (response.error) {
      notifyToaster(response.error || GENERIC_ERROR_MESSAGE, {
        type: TOASTIFY_STATUS.error,
      });
      throw new Error(response.error);
    }

    store.dispatch(setVehicles({ vehicles: response.result }));
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getVehicleDetails = async (data) => {
  try {
    const response = await getJSON(
        `${API_ENDPOINT_V4}/vehicles/search?search[vin]=${data.vin}&search[cache]=${data.cache}`,
        {},
        {
          Authorization: getCookie(AUTHENTICATION_TOKEN),
        }
    );

    if (response.error) {
      throw new Error(response.error);
    }

    return response;
  } catch (error) {
    throw new Error(error.message);
  }
}

export const licensePlateToVIN = async (data) => {
  try {
    const response = await getJSON(
        `${API_ENDPOINT_V4}/vehicle_plate/convert_plate`,
        { license_plate_number: data.license, license_plate_state: data.selectedState },
        {
          Authorization: getCookie(AUTHENTICATION_TOKEN),
        }
    );

    if (response.error) {
      throw new Error(response.error);
    }

    return response.result;
  } catch (error) {
    throw new Error(error.message);
  }
}


export const updateVehicleEnrollment = async ({vehicleId, fleetId, enroll_code}) => {
  try {
    const response = await patchJSON(
        `${API_ENDPOINT_V4}/fleet/${fleetId}/fleetcor_vehicles/${vehicleId}`,
        {
          enroll_code: enroll_code
        },
        {
          Authorization: getCookie(AUTHENTICATION_TOKEN)
        }
    );

    if (response.error) {
      notifyToaster(response.error || GENERIC_ERROR_MESSAGE, {
        type: TOASTIFY_STATUS.error,
      });
      throw new Error(response.error);
    }

    return response;
  } catch (error) {
    throw new Error(error.message);
  }
}
